import React from 'react';
import MuiPaper from '@mui/material/Paper';

const Paper = (props) => <MuiPaper {...props} />;

export default Paper;
